export const RON_PROVIDER_LABELS: Record<string, string> = {
  pactima: 'Pactima',
  proof: 'Proof',
  notary_cam: 'NotaryCam'
}
